module.exports = __webpack_public_path__ + "static/media/HeaderNew.735a44a5.svg";